import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { stardardRequest } from '../../utils';
import { API_BASE } from '../../constants/api.constant'

import {
  USER_ACTIVITY_FETCH,
  USER_ACTIVITY_SET_FILTERS,
  USER_ACTIVITY_FETCH_BY_ID,
} from '../actions';

export function* watchFetchRequest() {
  const action = USER_ACTIVITY_FETCH
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      const filters = state.userActivity.grid_options.activity.filters||{}
      const data = {...filters, ...payload}
      return {
        method: 'post',
        url: `${API_BASE}/user-activity/fetch`,
        data: data
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export function* watchFiltersRequest() {
  yield takeEvery(USER_ACTIVITY_SET_FILTERS.REQUEST, function* ({ payload }) {
    if (payload.mode === 'user-activity-details') {
      yield put(USER_ACTIVITY_FETCH_BY_ID.requestAction({}))
    } else {
      yield put(USER_ACTIVITY_FETCH.requestAction({}))
    }
  })
}

export function* watchFetchIdRequest() {
  const action = USER_ACTIVITY_FETCH_BY_ID
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload, state) => {
      const filters = state.userActivity.grid_options.activity.filters||{}
      const data = {...filters, ...payload}
      return {
        method: 'post',
        url: `${API_BASE}/user-activity/details`,
        data: data
      }
    },
    dataPath: 'result',
    dataDefault: [],
  }));
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchFetchIdRequest),
    fork(watchFiltersRequest),
  ]);
}